/**
 * Created by jan on 9-3-15.
 */
// Swedish stopwords
// http://www.ranks.nl/stopwords/swedish
// https://github.com/AlexGustafsson

module.exports = {
    stopwords: [
        "aderton",
        "adertonde",
        "adjö",
        "aldrig",
        "alla",
        "allas",
        "allt",
        "alltid",
        "alltså",
        "än",
        "andra",
        "andras",
        "annan",
        "annat",
        "ännu",
        "artonde",
        "artonn",
        "åtminstone",
        "att",
        "åtta",
        "åttio",
        "åttionde",
        "åttonde",
        "av",
        "även",
        "båda",
        "bådas",
        "bakom",
        "bara",
        "bäst",
        "bättre",
        "behöva",
        "behövas",
        "behövde",
        "behövt",
        "beslut",
        "beslutat",
        "beslutit",
        "bland",
        "blev",
        "bli",
        "blir",
        "blivit",
        "bort",
        "borta",
        "bra",
        "då",
        "dag",
        "dagar",
        "dagarna",
        "dagen",
        "där",
        "därför",
        "de",
        "del",
        "delen",
        "dem",
        "den",
        "deras",
        "dess",
        "det",
        "detta",
        "dig",
        "din",
        "dina",
        "dit",
        "ditt",
        "dock",
        "du",
        "efter",
        "eftersom",
        "elfte",
        "eller",
        "elva",
        "en",
        "enkel",
        "enkelt",
        "enkla",
        "enligt",
        "er",
        "era",
        "ert",
        "ett",
        "ettusen",
        "få",
        "fanns",
        "får",
        "fått",
        "fem",
        "femte",
        "femtio",
        "femtionde",
        "femton",
        "femtonde",
        "fick",
        "fin",
        "finnas",
        "finns",
        "fjärde",
        "fjorton",
        "fjortonde",
        "fler",
        "flera",
        "flesta",
        "följande",
        "för",
        "före",
        "förlåt",
        "förra",
        "första",
        "fram",
        "framför",
        "från",
        "fyra",
        "fyrtio",
        "fyrtionde",
        "gå",
        "gälla",
        "gäller",
        "gällt",
        "går",
        "gärna",
        "gått",
        "genast",
        "genom",
        "gick",
        "gjorde",
        "gjort",
        "god",
        "goda",
        "godare",
        "godast",
        "gör",
        "göra",
        "gott",
        "ha",
        "hade",
        "haft",
        "han",
        "hans",
        "har",
        "här",
        "heller",
        "hellre",
        "helst",
        "helt",
        "henne",
        "hennes",
        "hit",
        "hög",
        "höger",
        "högre",
        "högst",
        "hon",
        "honom",
        "hundra",
        "hundraen",
        "hundraett",
        "hur",
        "i",
        "ibland",
        "idag",
        "igår",
        "igen",
        "imorgon",
        "in",
        "inför",
        "inga",
        "ingen",
        "ingenting",
        "inget",
        "innan",
        "inne",
        "inom",
        "inte",
        "inuti",
        "ja",
        "jag",
        "jämfört",
        "kan",
        "kanske",
        "knappast",
        "kom",
        "komma",
        "kommer",
        "kommit",
        "kr",
        "kunde",
        "kunna",
        "kunnat",
        "kvar",
        "länge",
        "längre",
        "långsam",
        "långsammare",
        "långsammast",
        "långsamt",
        "längst",
        "långt",
        "lätt",
        "lättare",
        "lättast",
        "legat",
        "ligga",
        "ligger",
        "lika",
        "likställd",
        "likställda",
        "lilla",
        "lite",
        "liten",
        "litet",
        "man",
        "många",
        "måste",
        "med",
        "mellan",
        "men",
        "mer",
        "mera",
        "mest",
        "mig",
        "min",
        "mina",
        "mindre",
        "minst",
        "mitt",
        "mittemot",
        "möjlig",
        "möjligen",
        "möjligt",
        "möjligtvis",
        "mot",
        "mycket",
        "någon",
        "någonting",
        "något",
        "några",
        "när",
        "nästa",
        "ned",
        "nederst",
        "nedersta",
        "nedre",
        "nej",
        "ner",
        "ni",
        "nio",
        "nionde",
        "nittio",
        "nittionde",
        "nitton",
        "nittonde",
        "nödvändig",
        "nödvändiga",
        "nödvändigt",
        "nödvändigtvis",
        "nog",
        "noll",
        "nr",
        "nu",
        "nummer",
        "och",
        "också",
        "ofta",
        "oftast",
        "olika",
        "olikt",
        "om",
        "oss",
        "över",
        "övermorgon",
        "överst",
        "övre",
        "på",
        "rakt",
        "rätt",
        "redan",
        "redigera",
        "så",
        "sade",
        "säga",
        "säger",
        "sagt",
        "samma",
        "sämre",
        "sämst",
        "se",
        "sedan",
        "senare",
        "senast",
        "sent",
        "sex",
        "sextio",
        "sextionde",
        "sexton",
        "sextonde",
        "sig",
        "sin",
        "sina",
        "sist",
        "sista",
        "siste",
        "sitt",
        "sjätte",
        "sju",
        "sjunde",
        "sjuttio",
        "sjuttionde",
        "sjutton",
        "sjuttonde",
        "ska",
        "skall",
        "skulle",
        "slutligen",
        "små",
        "smått",
        "snart",
        "som",
        "stor",
        "stora",
        "större",
        "störst",
        "stort",
        "tack",
        "tidig",
        "tidigare",
        "tidigast",
        "tidigt",
        "till",
        "tills",
        "tillsammans",
        "tio",
        "tionde",
        "tjugo",
        "tjugoen",
        "tjugoett",
        "tjugonde",
        "tjugotre",
        "tjugotvå",
        "tjungo",
        "tolfte",
        "tolv",
        "tre",
        "tredje",
        "trettio",
        "trettionde",
        "tretton",
        "trettonde",
        "två",
        "tvåhundra",
        "under",
        "upp",
        "ur",
        "ursäkt",
        "ut",
        "utan",
        "utanför",
        "ute",
        "vad",
        "vänster",
        "vänstra",
        "vår",
        "vara",
        "våra",
        "varför",
        "varifrån",
        "varit",
        "varken",
        "värre",
        "varsågod",
        "vart",
        "vårt",
        "vem",
        "vems",
        "verkligen",
        "vi",
        "vid",
        "vidare",
        "viktig",
        "viktigare",
        "viktigast",
        "viktigt",
        "vilka",
        "vilken",
        "vilket",
        "vill",
        "är",
        "år",

        "även",
        "dessa",
        "wikitext",
        "wikipedia",
        "tyngre",
        "tung",
        "tyngst",
        "kall",
        "var",
        "minimum",
        "min",
        "max",
        "maximum",
        "ökning",
        "öka",
        "kallar",
        "hjälp",
        "använder",
        "betydligt",
        "sätt",
        "denna",
        "detta",
        "det",
        "hjälpa",
        "används",
        "består",
        "tränger",
        "igenom",
        "denna",
        "utöka",
        "utarmat",
        "ungefär",
        "sprids",
        "betydligt",
        "omgivande",
        "via",
        "huvudartikel",
        "exempel",
        "exempelvis",
        "vanligt",
        "per",
        "största",
        "stor",
        "ord",
        "ordet",
        "kallas",
        "påbörjad",
        "höra",
        "främst",
        "ihop",
        "antalet",
        "the",
        "uttryck",
        "uttrycket",
        "ändra",
        "presenteras",
        "presenterades",
        "tänka",
        "delar",
        "söka",
        "hämta",
        "innehåll",
        "definera",
        "använda",
        "pekar",
        "istället",
        "stället",
        "pekar",
        "standard",
        "vanligaste",
        "heter",
        "precist",
        "felaktigt",
        "källor",
        "höga",
        "mottagare",
        "eng",
        "bildade",
        "bytte",
        "bildades",
        "grundades",
        "svar",
        "betyder",
        "betydelse",
        "möjligheter",
        "möjlig",
        "möjlighet",
        "syfte",
        "gamla",
        "tioårig",
        "år",
        "övergångsperiod",
        "ersättas",
        "användes",
        "används",
        "utgörs",
        "drygt",
        "alla",
        "allt",
        "alltså",
        "andra",
        "att",
        "bara",
        "bli",
        "blir",
        "borde",
        "bra",
        "mitt",
        "ser",
        "dem",
        "den",
        "denna",
        "det",
        "detta",
        "dig",
        "din",
        "dock",
        "dom",
        "där",
        "edit",
        "efter",
        "eftersom",
        "eller",
        "ett",
        "fast",
        "fel",
        "fick",
        "finns",
        "fram",
        "från",
        "får",
        "fått",
        "för",
        "första",
        "genom",
        "ger",
        "går",
        "gör",
        "göra",
        "hade",
        "han",
        "har",
        "hela",
        "helt",
        "honom",
        "hur",
        "här",
        "iaf",
        "igen",
        "ingen",
        "inget",
        "inte",
        "jag",
        "kan",
        "kanske",
        "kommer",
        "lika",
        "lite",
        "man",
        "med",
        "men",
        "mer",
        "mig",
        "min",
        "mot",
        "mycket",
        "många",
        "måste",
        "nog",
        "när",
        "någon",
        "något",
        "några",
        "nån",
        "nåt",
        "och",
        "också",
        "rätt",
        "samma",
        "sedan",
        "sen",
        "sig",
        "sin",
        "själv",
        "ska",
        "skulle",
        "som",
        "sätt",
        "tar",
        "till",
        "tror",
        "tycker",
        "typ",
        "upp",
        "utan",
        "vad",
        "var",
        "vara",
        "vet",
        "vid",
        "vilket",
        "vill",
        "väl",
        "även",
        "över",
        "förekommer",
        "varierar",
        "representera",
        "representerar",
        "itu",
        "påbörjades",
        "le",
        "åtgärder",
        "åtgärd",
        "sådant",
        "särskilt",
        "eftersom",
        "som",
        "efter",
        "syftet",
        "syfte",
        "ersatts",
        "ersätts",
        "ersatt",
        "ersätt",
        "tagits",
        "byter",
        "benämningar",
        "ler",
        "ärvs",
        "ärv",
        "ärvd",
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december",
        "on",
        "övriga",
        "använts",
        "använd",
        "används",
        "använt",
        "syftar",
        "ex",
        "svårt",
        "svår",
        "lätt",
        "lätta",
        "lättast",
        "lättare",
        "svårare",
        "svårast",
        "list",
        "användningsområde",
        "användningsområden",
        "vissa",
        "ii",
        "hembyggda",
        "krav",
        "lugnt",
        "ändå",
        "stycken",
        "styck",
        "långa",
        "korta",
        "små",
        "stora",
        "smala",
        "tjocka",
        "början",
        "tungt",
        "lätt",
        "tim",
        "st",
        "kg",
        "km",
        "tid",
        "ny",
        "gammal",
        "nyare",
        "antal",
        "snabbare",
        "började",
        "ansvar",
        "ansvarar",
        "både",
        "ca",
        "låg",
        "hög",
        "ro",
        "ton",
        "kap",
        "of",
        "and",
        "vars",
        "kr/km",
        "rör",
        "gällande",
        "placeras",
        "placerades",
        "täckt",
        "samt",
        "hos",
        "sådana",
        "endast",
        "tillstånd",
        "beror",
        "på",
        "marken",
        "minska",
        "orsaker",
        "lösningar",
        "problem",
        "namn",
        "förväntas",
        "förväntan",
        "förväntats",
        "varning",
        "utfärdas",
        "utfärda",
        "km/h",
        "nådde",
        "stod",
        "området",
        "områden",
        "källa",
        "behövs",
        "drabbade",
        "drabbat",
        "which",
        "top",
        "that",
        "lägre",
        "allmänt",
        "drog",
        "drar",
        "enorma",
        "ända",
        "enda",
        "officiella",
        "bekräftats",
        "bekräftas",
        "fall",
        "sjunker",
        "nedåt",
        "värms",
        "samtidigt",
        "efterföljd",
        "problematik",
        "uppåt",
        "utom",
        "förutom",
        "hörnet",
        "söt",
        "salt",
        "svag",
        "stark",
        "ren",
        "smutsig",
        "förr",
        "tiden",
        "mångdag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lördag",
        "söndag",
        "måndagar",
        "tisdagar",
        "onsdagar",
        "torsdagar",
        "fredagar",
        "lördagar",
        "söndagar",
        "efterlikna",
        "som",
        "lik",
        "bergis",
        "bekymmer",
        "så",
        "lista",
        "dig",
        "dej",
        "mig",
        "mej",
        "fri",
        "vanlig",
        "ovanlig",
        "sällan",
        "ofta",
        "avskiljs",
        "use",
        "släkte",
        "släktet",
        "släkt",
        "kategori",
        "kategoriseras",
        "rensas",
        "renas",
        "timmar",
        "minuter",
        "sekunder"
    ]
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/lib/stopwords/se.js
 ** module id = 3001
 ** module chunks = 0
 **/